<template>
    <div class="shop-photos-page">
        <systemphotos
            :isshow="true"
            :embedded="true"
            :selectable="false"
            phototype="shop"
            dialogTitle="商户图集"
        />
    </div>
</template>

<script>
import systemphotos from '@/components/systemphotos/index';

export default {
    name: 'ShopPhotos',
    components: {
        systemphotos,
    },
    methods: {
        OnloadMethod() {},
        BrotherComponentIn() {},
        freshdata() {},
    },
};
</script>

<style scoped>
.shop-photos-page {
    width: 100%;
    min-height: 620px;
}
</style>
